import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'view-settings.filter-panel.fieldless-filter-name': {
    id: 'view-settings.filter-panel.fieldless-filter-name',
    defaultMessage: 'Undefined',
    description:
      'The text displayed for a filter in the Filter view settings panel when the filter does not have a field associated with it',
  },
});
